import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const RECENT_PURCHASES = [{
  name: 'María',
  city: 'Córdoba'
}, {
  name: 'Carlos',
  city: 'Rosario'
}, {
  name: 'Laura',
  city: 'Mendoza'
}, {
  name: 'Jorge',
  city: 'Mar del Plata'
}, {
  name: 'Ana',
  city: 'San Miguel de Tucumán'
}, {
  name: 'Roberto',
  city: 'Buenos Aires'
}, {
  name: 'Silvia',
  city: 'La Plata'
}, {
  name: 'Eduardo',
  city: 'Santa Fe'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(RECENT_PURCHASES[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Rotate notifications
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomIndex = Math.floor(Math.random() * RECENT_PURCHASES.length);
        setCurrentPurchase(RECENT_PURCHASES[randomIndex]);
        setIsVisible(true);
      }, 1000); // Wait for exit animation
    }, 10000); // Show every 10 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <div className={`fixed bottom-4 right-4 z-50 transition-all duration-500 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} data-id="element-1">
      <div className="bg-white rounded-lg shadow-lg p-4 flex items-center gap-3 max-w-xs border border-blue-100" data-id="element-2">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-3">
          <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-4" />
        </div>
        <div data-id="element-5">
          <p className="text-sm font-medium text-gray-900" data-id="element-6">
            {currentPurchase.name} – {currentPurchase.city}
          </p>
          <p className="text-xs text-gray-500" data-id="element-7">
            acaba de comprar este libro digital
          </p>
        </div>
      </div>
    </div>;
}